import { forwardRef } from 'react';
import type { BaseIconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export interface IconProps extends Omit<BaseIconProps, 'pixelSize'> {
  /**
   * Size of the icons. Only 3 sizes supported, to result in 16/32/48 px.
   */
  size?: 'm' | 'l' | 'xl';
}

const SIZES = {
  m: 16,
  l: 32,
  xl: 48,
};

/**
 * Icon component
 *
 * {@link https://zeroheight.com/76c439891/v/latest/p/97d80d-icons Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-icon--basic-icon Code documentation}
 *
 * @example
 * <Icon icon="bell" />
 */
export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }: IconProps, ref) => (
    <BaseIcon ref={ref} pixelSize={SIZES[size]} {...props} />
  ),
);

Icon.displayName = 'Icon';
Icon.defaultProps = {
  inline: false,
  size: 'm',
};
